import { isHomePage } from '~/utils/router';
import { defineStore } from 'pinia';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';

export type AdfoxParams = {
  lh_adfox_homepage: boolean;
  lh_adfox_rtn: boolean;
  lh_adfox_noad: string;
  lh_adfox_noadsense: string;
  lh_adfox_pk: string;
  lh_adfox_postid: string;
  lh_adfox_streams: string;
  lh_adfox_tags: string;
  lh_adfox_terms: string;
  lh_adfox_ipv6: number;
};

export type AdfoxParamsWithIp = AdfoxParams & {
  lh_adfox_ipv6: 1 | 0;
};

const defaultAdfox: AdfoxParams = {
  lh_adfox_homepage: false,
  lh_adfox_rtn: false,
  lh_adfox_noad: '',
  lh_adfox_noadsense: '',
  lh_adfox_pk: '',
  lh_adfox_postid: '',
  lh_adfox_streams: '',
  lh_adfox_tags: '',
  lh_adfox_terms: '',
  lh_adfox_ipv6: 0,
};

export const useAdfoxStore = wrapPiniaStore(
  defineStore('adfox', () => {
    const isIpV6 = ref(false);
    const params = ref<AdfoxParams>({ ...defaultAdfox });

    const { $logger } = useNuxtApp();
    const log = $logger.withScope('adfox store');

    const currentAdfox = computed<AdfoxParamsWithIp>(() => {
      const route = useRoute();

      return {
        ...params.value,
        lh_adfox_homepage: isHomePage(route.name) || params.value.lh_adfox_homepage,
        lh_adfox_ipv6: isIpV6.value ? 1 : 0,
      };
    });

    async function addAdfoxIpV6() {
      const { $wordpressApi, $logger } = useNuxtApp();
      const response = await $wordpressApi.defineIpv();

      isIpV6.value = response.data.v === 6;
      $logger('adfox', isIpV6.value ? 'ipv6' : 'ipv4');
    }

    function addAdfoxParams(adfoxParams: Partial<AdfoxParams>) {
      if (!adfoxParams) return log.warn('No data passed into addAdfoxParams');
      Object.assign(params.value, adfoxParams);
    }

    return {
      params,
      currentAdfox,
      addAdfoxIpV6,
      addAdfoxParams,
    };
  }),
);
